module.exports = __webpack_public_path__ + "static/media/android_consulting.4dc1c367.png";